import queryString from 'query-string'


export const getParamsSearch = (location: Location) => {
  const params1 = queryString.parse(window.location.search)
  const params2 = queryString.parse(location.search)
  return { ...params1, ...params2 }
}

const getString = (v: any) => {
  if (typeof v !== 'string') {
    return ''
  }
  return v
}


export const IdKey = 'orderSn-sss'
export const ParamsKey = '12333-sss-3333'

export const PhoneReg = RegExp(/^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[89])\d{8}$/)
/**
 * 判断手机类型
 */
export function judgePhoneType() {
  const u = navigator.userAgent
  const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1
  const isIos = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  return { isAndroid, isIos }
}


/**
 * 获取随机手机号
 */
export function generateRandomPhoneNumber() {
  // 随机3位数字
  const prefix = '134 135 136 137 138 139 147 150 151 152 157 158 159 166 170 171 172 180 181 182 183 184 185 186 187 188 189 198'
    .split(' ')
    .sort(() => Math.random() - 0.5)
    .shift();
  // 随机4位数字
  const middle = ('' + Math.random()).slice(2, 6);
  // 随机4位数字
  const end = ('' + Math.random()).slice(2, 6);
  return `${prefix}****${end}`;
}
